// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9cebe69","455":"752f6106"}[chunkId] + ".chunk.js";
};